<template>
  <span class="vs-animated-number"></span>
</template>

<script>
import _ from 'lodash';
import CountUp from 'countup.js';

export default {
  name: 'VSAnimatedNumber',
  props: {
    value: {
      type: Number,
      required: true,
    },
    initial: {
      type: Number,
      default: 0,
    },
    decimals: {
      type: Number,
      default: 0,
    },
    time: {
      type: Number,
      default: 500,
    },
    debounce: {
      type: Number,
      default: 250,
    },
    start: {
      type: Boolean,
      default: true,
    },
    separator: {
      type: String,
      default: ',',
    },
    decimal: {
      type: String,
      default: '.',
    },
    prefix: {
      type: String,
      default: '',
    },
    suffix: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      countUp: {},
      options: {
        useEasing: true,
        useGrouping: true,
        separator: this.separator,
        decimal: this.decimal,
        prefix: this.prefix,
        suffix: this.suffix,
      },
    };
  },
  computed: {
    duration() {
      // Convert ms to seconds for plugin
      return this.time / 1000;
    },
  },
  methods: {
    startCounting() {
      this.countUp.start();
    },
    // Overwritten on create
    update() {},
  },
  watch: {
    value(updated) {
      this.update(updated);
    },
    start() {
      this.startCounting();
    },
  },
  created() {
    /* istanbul ignore next */
    this.update = _.debounce((value) => {
      this.countUp.update(value);
    }, this.debounce);
  },
  mounted() {
    this.countUp = new CountUp(
      this.$el,
      this.initial,
      this.value,
      this.decimals,
      this.duration,
      this.options,
    );

    if (this.start) {
      this.startCounting();
    }
  },
};
</script>
